var format = require('date-format')

if (!console) {
  console = {}
}
if (!console.log) {
  console.log = () => {}
}
const showLog = !!localStorage.getItem('showPlayerLog')
export const getLogger = name => {
  return {
    debug: (...args) => {
      if (process.env.NODE_ENV != 'development' || !showLog) return

      try {
        console.log.apply(console, ['[' + format() + '][DEBUG] - ' + name].concat(args))
      } catch (e) {
        console.log(['[' + format() + '][DEBUG] - ' + name].concat(args).join(' '))
      }
    },
    info: (...args) => {
      if (!showLog) return
      try {
        console.log.apply(console, ['[' + format() + '][INFO] - ' + name].concat(args))
      } catch (e) {
        console.log(['[' + format() + '][INFO] - ' + name].concat(args).join(' '))
      }
    },
    warn: (...args) => {
      if (!showLog) return
      try {
        console.log.apply(console, ['[' + format() + '][WARN] - ' + name].concat(args))
      } catch (e) {
        console.log(['[' + format() + '][WARN] - ' + name].concat(args).join(' '))
      }
    },
  }
}
export default {
  getLogger,
}
